import {TextureType} from "@generated"
import {ImageOpNodeDataObject} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/data-object/node"
import {DownloadFormat} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object"
import {descriptorByTextureType} from "@app/textures/utils/texture-type-descriptor"

// Builds the graph entry node that loads a texture type's own source data object -- shared by
// anything that needs to generate an operator graph for a specific texture type independently of
// whatever is currently shown in the live viewport (job baking, or forcing a HAL/preview pass).
export function createSourceDataObjectNode(
    textureType: TextureType,
    dataObjectId: string,
    downloadFormat: DownloadFormat,
    debugIdPrefix: string,
): ImageOpNodeDataObject {
    const channels = descriptorByTextureType(textureType).channelLayout.length
    const sourceImage = new ImageOpNodeDataObject({
        dataObjectId,
        downloadFormat,
        channels,
    })
    sourceImage.debugId = `${debugIdPrefix}-${textureType}-${dataObjectId}`
    return sourceImage
}
